import React from 'react';
import styled from 'styled-components';
import CtaPrimary from 'components/ui/CtaPrimary';
import { media } from 'helpers/MediaHelper';

import { colors } from 'helpers/ColorHelper';

const StyledFooterContainer = styled.div`
  background-color: #fff;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 1rem 1.5rem;
  border-top: 1px solid #e6e6f0;

  ${media.mobile`
    text-align: center;
  `};
`;

const StyledButtonContainer = styled.div`
  display: flex;

  ${media.mobile`
    display: ${(props) => (props.secondaryText ? 'block' : 'flex')};
    text-align: center;
  `};
`;

const StyledTitleFooterContainer = styled(StyledFooterContainer)`
  display: block !important;
`;

const RightAlignedMenu = styled.div`
  flex-grow: 1;
  justify-content: flex-end;
  align-items: center;
  display: inline-flex;
`;

const SecondaryText = styled.div`
  color: #74777a;
  padding-top: 8px;
  ${media.mobile`
    margin-bottom: 8px;
    padding: 0;
  `};
`;

const StyledTitle = styled.div`
  margin-bottom: 5px;
  font-size: 16px;
  font-family: 'Circular-Black';
`;

const StyledTopTitle = styled.p`
  font-family: 'Circular-Bold';
`;

const StyledSecondaryButton = styled.div`
  color: ${colors.ULTRAMARINE_BLUE};
  padding: 8px 0;
`;

export default (props) => {
  if (props.noAction) {
    return (
      <StyledTitleFooterContainer>
        <StyledTitle>{props.descriptionTitle}</StyledTitle>
        <p>{props.descriptionSubtitle}</p>
      </StyledTitleFooterContainer>
    );
  }

  return (
    <StyledFooterContainer secondaryText={props.secondaryText}>
      {props.topTitleText && <StyledTopTitle>{props.topTitleText}</StyledTopTitle>}
      <StyledButtonContainer secondaryText={props.secondaryText}>
        {props.secondaryActionText && (
          <StyledSecondaryButton
            className="link-button"
            onClick={props.onSecondaryActionClick}
            disabled={props.secondaryActionDisabled || !props.onSecondaryActionClick}
          >
            {props.secondaryActionText}
          </StyledSecondaryButton>
        )}
        {props.secondaryText && <SecondaryText>{props.secondaryText}</SecondaryText>}
        {props.primaryActionText && (
          <RightAlignedMenu>
            <CtaPrimary
              form={props.primaryActionFormName}
              type={props.primaryActionFormName ? 'submit' : 'button'}
              accentColor={props.primaryActionColor}
              onClick={props.onPrimaryActionClick}
              disabled={props.primaryActionDisabled}
            >
              {props.primaryActionText}
            </CtaPrimary>
          </RightAlignedMenu>
        )}
      </StyledButtonContainer>
    </StyledFooterContainer>
  );
};
